import { format } from 'date-fns/format'
import { useMemo, useState } from 'react'

interface DateOption {
  date: string
  weekday: string
  monthAndDay: string
}

export const DEFAULT_VISIBLE_DATES_PER_PAGE = 4
export const DEFAULT_TOTAL_DATES = 30

export const useDatePickerCarrouselDates = ({
  datesToGenerate = DEFAULT_TOTAL_DATES,
  datesPerPage = DEFAULT_VISIBLE_DATES_PER_PAGE,
}: { datesToGenerate?: number; datesPerPage?: number } = {}) => {
  const [datesCarrouselStartIndex, setDatesCarrouselStartIndex] = useState(0)

  const totalDates = useMemo(() => {
    const result: DateOption[] = []
    const today = new Date()

    for (let i = 0; i < datesToGenerate; i++) {
      const date = new Date(today)
      date.setDate(today.getDate() + i)

      result.push({
        date: format(date, 'yyyy-MM-dd'),
        weekday: date.toLocaleDateString('en-CA', { weekday: 'short' }),
        monthAndDay: date.toLocaleString('en-CA', { month: 'short', day: 'numeric' }),
      })
    }

    return result
  }, [datesToGenerate])

  const currentVisibleDates = useMemo(
    () => totalDates.slice(datesCarrouselStartIndex, datesCarrouselStartIndex + datesPerPage),
    [totalDates, datesCarrouselStartIndex, datesPerPage]
  )

  const handlePreviousDates = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    setDatesCarrouselStartIndex((prev) => prev - datesPerPage)
  }

  const handleNextDates = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    setDatesCarrouselStartIndex((prev) => prev + datesPerPage)
  }

  return {
    totalDates,
    dates: currentVisibleDates,
    handlePreviousDates,
    handleNextDates,
    datesCarrouselStartIndex,
  }
}
